/* Keep the merchant rating badge out of the initial storefront workload. */
(() => {
  const config = document.currentScript?.dataset;
  if (!config || !config.merchantId) return;

  let pending = true;
  let idleId;
  let timerId;

  function cleanup() {
    window.removeEventListener('load', schedule);
    window.removeEventListener('pointerdown', onInteraction);
    window.removeEventListener('keydown', onInteraction);
    if (idleId !== undefined) window.cancelIdleCallback?.(idleId);
    if (timerId !== undefined) clearTimeout(timerId);
  }

  function loadWidget() {
    if (!pending) return;
    pending = false;
    cleanup();
    if (document.getElementById('merchantWidgetScript')) return;

    const script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.async = true;
    script.addEventListener('load', () => {
      if (script.dataset.elechidStarted || !window.merchantwidget?.start) return;
      script.dataset.elechidStarted = 'true';
      try {
        window.merchantwidget.start({
          merchant_id: Number(config.merchantId),
          position: config.position,
          region: config.region
        });
      } catch (_) {
        // A rating-provider failure must not interrupt storefront controls.
      }
    }, { once: true });
    document.body.appendChild(script);
  }

  function schedule() {
    if (!pending || idleId !== undefined || timerId !== undefined) return;
    if (window.requestIdleCallback) {
      idleId = window.requestIdleCallback(loadWidget, { timeout: 2000 });
    } else {
      timerId = setTimeout(loadWidget, 0);
    }
  }

  function onInteraction(event) {
    if (event.isTrusted) loadWidget();
  }

  window.addEventListener('pointerdown', onInteraction, { passive: true });
  window.addEventListener('keydown', onInteraction, { passive: true });
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
